




















import Vue from 'vue';
import { AppModuleNavItem} from '../models/AppModuleConfig';

export default Vue.extend({
  props: ['module', 'page'],
  methods: {
    selectedStatus(nav: AppModuleNavItem): string {
      return nav.alias === this.page ? 'selected' : '';
    },
  },
});
